import React from "react"
import { breakpoints, responsive } from "buoy-theme"
import LazyLoad from "react-lazyload"
import { getImageUrl } from "./utils"

export const LazyResImage = ({
  src,
  height,
  width,
  alt,
  srcSet = null,
  children,
}) => {
  let full_src = getImageUrl(src)
  let w = width
  let h = height

  if (width) {
    w = Number.isInteger(width) ? width : parseInt(width.replace("px", ""))
  }

  if (height) {
    h = Number.isInteger(height) ? height : parseInt(height.replace("px", ""))
  }

  return (
    <LazyLoad offset={200} once>
      {React.cloneElement(children, {
        src: full_src,
        height: h,
        width: w,
        alt: alt,
        srcSet:
          full_src.endsWith("svg") || full_src.endsWith("gif")
            ? null
            : `
            ${full_src}?auto=compress,format&width=${breakpoints.lg *
                2}&crop=fit ${breakpoints.lg * 2}w, 
            ${full_src}?auto=compress,format&width=${breakpoints.md *
                2}&crop=fit ${breakpoints.md * 2}w,
            ${full_src}?auto=compress,format&width=${breakpoints.sm *
                2}&crop=fit ${breakpoints.sm * 2}w`,
      })}
    </LazyLoad>
  )
}

export { responsive as default }



// WEBPACK FOOTER //
// ./src/common/responsive.js